import React, { Fragment } from 'react';
import PropTypes from "prop-types";

import { connect } from 'react-redux';
import { patchSocialLink, deleteSocialLink } from 'redux/social/actions';

import CommonLinkContainer
  from 'components/common/link-elements/CommonLinkContainer';
import SocialLinkCustomLabel
  from 'components/dashboard/social-content/SocialLinkCustomLabel';
import SocialLinkItemValue
  from 'components/dashboard/social-content/SocialLinkItemValue';
import SocialLinkIsButton
  from 'components/dashboard/social-content/SocialLinkIsButton';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';

import './SocialLinksListItem.css';

const headerContent = (item, deleteSocialLink, device) => (
  <div className="header-content">
    <div className="custom-label">
      <SocialLinkCustomLabel
        key={`social-link-custom-label-key-${item.id}`}
        item={item}
      />
    </div>

    <div className="value">
      <SocialLinkItemValue item={item} />
    </div>

    {device === 'desktop' &&
      <Fragment>
        <div className="is-button">
          <SocialLinkIsButton
            key={`social-link-is-button-key-${item.id}`}
            itemId={item.id}
            isButton={item.is_button}
          />
        </div>

        <div className="delete">
          <CommonLinkDeleteButton
            key={`social-link-delete-button-key-${item.id}`}
            linkItem={item}
            deleteFunction={deleteSocialLink}
          />
        </div>
      </Fragment>
    }
  </div>
);

const expandedContent = (item, deleteSocialLink) => (
  <div className="expanded-content">
    <div className="is-button">
      <SocialLinkIsButton
        key={`social-link-is-button-mobile-key-${item.id}`}
        itemId={item.id}
        isButton={item.is_button}
      />
    </div>

    <div className="delete">
      <CommonLinkDeleteButton
        key={`social-link-delete-button-mobile-key-${item.id}`}
        linkItem={item}
        deleteFunction={deleteSocialLink}
      />
    </div>
  </div>
);


function SocialLinksListItem(props) {
  const {
    item,
    deleteSocialLink,
    device,
    patchSocialLink,
  } = props;

  return (
    <div className="social-links-list-item__component">
      <CommonLinkContainer
        linkItem={item}
        patchLinkFunction={patchSocialLink}
        allowExpand={(device !== 'desktop')}
        headerContent={headerContent(item, deleteSocialLink, device)}
        expandedContent={expandedContent(item, deleteSocialLink)}
      />
    </div>
  );
}

SocialLinksListItem.propTypes = {
  patchSocialLink: PropTypes.func.isRequired,
  deleteSocialLink: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  device: PropTypes.string.isRequired,
};

const mapStateToProps = state => (
  {
    device: state.commonReducer.device,
  }
);

export default connect(
  mapStateToProps,
  {
    patchSocialLink,
    deleteSocialLink,
  },
)(SocialLinksListItem);
